define('app-Accordions/settings',[],function () {
    return {
        tabs: '.app-Tabs',
        tab: '.tab',
        tabLink: '.tabLink',
        activeTabUrlKey: 'app-Tabs-activeTab',
        keyinformation: '.keyinformation',
        tabColours: [
            'light-blue',
            'cyan-hover',
            'dark-blue',
            'turquoise',
            'green',
            'orange',
        ]
    };
});
